import { FC } from "react"
import { OnboardingFollows } from "../Components/OnboardingFollows"

export const OnboardingFollowGalleries: FC = () => {
  return <OnboardingFollows kind="galleries" />
}
